import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Modal, Row } from 'antd';
import { deleteFinPlan } from '../../data/store/account/accountActions';
import { useHistory } from 'react-router-dom';

const ModalDeletePlan = ({
  userId, modalDeletePlan,
  setModalDeletePlan
}) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();
  const history = useHistory();

  const { financialPlan } = useSelector((state) => state.accountReducer);

  // const getFinPlanById = () => {
  //   return finPlan.find(i => i.id === +modalDeletePlan)?.name;
  // };

  const handleCloseDelModal = () => {
    setModalDeletePlan(null);
  };
  
  const afterDel = () => {
    setModalDeletePlan(null);
    history.replace(`/accounts/${userId}/lifetiming`);
  };

  const handleDelete = () => {
    dispatch(deleteFinPlan({ afterDel, clientId: userId, finplanId: modalDeletePlan }));
  };

  return (
    <Modal
        width={650}
        className="modal-content-paper"
        open={modalDeletePlan}
        onCancel={handleCloseDelModal}
        footer={null}
        zIndex={1600}>
        <Row justify="center">
          <Col className="modal-title">{t('MODAL_DELETE_TITLE')}</Col>
        </Row>
        <Row justify="center" className="modal-text-wrapper">
          <Col>
            <p className="modal-delete-text">{t('MODAL_DELETE_PLAN')}</p>
            <p className="modal-delete-name">{financialPlan?.name}</p>
          </Col>
        </Row>
        <Row className="modal-advisor-btn-wrapper">
          <Button
            className="modal-action-btn cancel-btn"
            onClick={handleCloseDelModal}
          >
            {t('CANCEL')}
          </Button>
          <Button className="modal-action-btn delete-btn" onClick={handleDelete}>
            {t('DELETE')}
          </Button>
        </Row>
      </Modal>
  );
};

export default ModalDeletePlan;

ModalDeletePlan.propTypes = {
  userId: PropTypes.string,
  modalDeletePlan: PropTypes.string,
  setModalDeletePlan: PropTypes.func,
};
